<script setup lang="ts">
import { HomeOutlined } from '@ant-design/icons-vue'
import { useBreadcrumb } from '@/composables/useBreadcrumb'

const { items } = useBreadcrumb()
</script>

<template>
  <a-breadcrumb class="app-breadcrumb">
    <a-breadcrumb-item v-for="(item, index) in items" :key="index">
      <RouterLink v-if="item.path" :to="item.path">
        <HomeOutlined v-if="index === 0" class="breadcrumb-icon" />
        <span>{{ item.title }}</span>
      </RouterLink>
      <span v-else>
        <HomeOutlined v-if="index === 0" class="breadcrumb-icon" />
        {{ item.title }}
      </span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<style scoped>
.app-breadcrumb {
  margin-bottom: 0;
  width: 100%;
  min-width: 0;
}

.app-breadcrumb :deep(.ant-breadcrumb ol) {
  flex-wrap: wrap;
  row-gap: 2px;
}

@media (max-width: 575px) {
  .app-breadcrumb :deep(.ant-breadcrumb ol) {
    font-size: 13px;
  }

  .app-breadcrumb :deep(.ant-breadcrumb-link) {
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    vertical-align: bottom;
  }

  .app-breadcrumb :deep(.ant-breadcrumb li:last-child .ant-breadcrumb-link) {
    max-width: 160px;
  }
}

.app-breadcrumb :deep(.ant-breadcrumb-link) {
  color: var(--ds-text-secondary);
  transition: color 0.2s ease;
}

.app-breadcrumb :deep(.ant-breadcrumb-link a) {
  color: var(--ds-text-secondary);
}

.app-breadcrumb :deep(.ant-breadcrumb-link a:hover) {
  color: var(--app-primary);
}

.app-breadcrumb :deep(.ant-breadcrumb-separator) {
  color: var(--ds-border);
}

.app-breadcrumb :deep(.ant-breadcrumb li:last-child .ant-breadcrumb-link) {
  color: var(--ds-primary);
  font-weight: 600;
}

.app-breadcrumb :deep(.ant-breadcrumb li:last-child .ant-breadcrumb-link span) {
  color: inherit;
}

.breadcrumb-icon {
  margin-right: 4px;
  vertical-align: -0.15em;
}
</style>
